import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { CurrencySymbolPipe } from '@app/pipes/currency-symbol.pipe';
import { DecimalInputComponent } from '@app/shared/decimal-input/decimal-input.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SbFormFieldComponent } from '@sb/ui/form-field';
import { IconComponent } from '@sb/ui/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'target-setting-setup',
  templateUrl: './target-setting-setup.component.html',
  imports: [
    TranslatePipe,
    DecimalInputComponent,
    SbFormFieldComponent,
    ReactiveFormsModule,
    IconComponent,
    CurrencySymbolPipe,
  ],
})
export class TargetSettingSetupComponent implements AfterViewInit {
  private translate = inject(TranslateService);
  private elementRef = inject(ElementRef);

  @Input()
  description: string;
  @Input()
  explanation: string;
  @Input()
  fieldLabel: string | SafeHtml;
  @Input()
  placeholder = this.translate.instant('Enter target value');
  @Input()
  prefix: 'currency' | 'percentage';
  @Input()
  control: FormControl<string>;

  ngAfterViewInit(): void {
    this.focusFirstInput();
  }

  private focusFirstInput() {
    const input = this.elementRef.nativeElement.querySelector('input');
    if (input) {
      input.focus();
    }
  }
}
